import { Component, OnInit, HostListener, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../auth/auth.service';
import { Constant } from '../constant';
import { Title } from '@angular/platform-browser';
import { CommonUtil } from '../util/common-util';
import { ToastUtil } from '../util/toast-util';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormArray, FormControl, FormBuilder, FormGroup, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { GeneralYesNoDialogComponent } from './../dialog/general-yes-no-dialog/general-yes-no-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TagSettingDialogComponent } from '../dialog/tag-setting-dialog/tag-setting-dialog.component';

interface GrandChildItem {
  id: string | null;
  relation;
  tag_id: string;
  member_count?: number;
  name: string;
  enabled: boolean;
  delete: boolean;
}

interface ChildItem {
  id: string | null;
  name: string;
  member_count?: number;
  enabled: boolean;
  delete: boolean;
  children: GrandChildItem[];
}

interface ParentItem {
  id: string | null;
  name: string;
  member_count?: number;
  enabled: boolean;
  delete: boolean;
  children: ChildItem[];
}

@Component({
    selector: 'master-settings',
    templateUrl: './master-settings.component.html',
    styleUrl: './master-settings.component.css',
    standalone: true,
    imports: [
      MatMenuModule,
      MatButtonModule,
      MatIconModule,
      CommonModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatSelectModule,
      MatInputModule,
      MatCardModule,
      MatSlideToggleModule,
      DragDropModule,
      MatCheckboxModule,
      MatProgressSpinnerModule,
      FormsModule,
    ]
})
export class MasterSettingsComponent {
  public tellNo = Constant.calinTellNo + Constant.calinWorkTime;
  public supportMail = Constant.calinSupportMail;
  public accounts;
  public isSaving = false;
  public tagMaster;
  public apiPath = '/master';
  public readonly Constant = Constant;
  public showSpinner = true;
  public form: FormGroup;
  public industryLarges;
  public employeeSizes;
  public locations;
  public jobTypes;
  public employmentTypes;
  public masterTypes;
  public cardLoading: { [key: number]: boolean } = {};
  public history: any = {};
  public deletedIds: number[] = [];
  public tagList: any[] = [];
  public isPermissionOpen = false;
  public authDescription: string = '';
  authDescriptionLength = 0;
  public authDescriptionHistory;

  constructor(
    private title: Title,
    private router: Router,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
    private dialog: MatDialog,
    private auth: AuthService,
    private fb: FormBuilder
  ) {
    this.title.setTitle(Constant.pageTitleMasterSettings + Constant.pageTitleCommon);

    this.masterTypes = [
      { type: 1, label: '本部', form: 'type1' },
      { type: 2, label: '支部', form: 'type2' },
      { type: 3, label: 'エリア', form: 'type3' },
      { type: 4, label: '専門部', form: 'type4' },
      { type: 5, label: '役職', form: 'type5' },
      { type: 6, label: '権限説明', form: 'type6' }
    ];

    this.masterTypes.forEach(m => {
      this.cardLoading[m.type] = false;
    });
  }

  @HostListener('window:focus')
  onFocus(): void {
    this.commonUtil.checkRefreshToken(this.auth);
  }

  ngOnInit() {
    window.scroll(0, 0);
    if (!this.commonUtil.checkOnline()) {
      this.showSpinner = false;
      return;
    }
    this.initForm();
    this.getTagMaster();

    this.getMasterData();
  }


  onTagRegist() {
    const elm = <HTMLElement>document.activeElement;
    elm.blur();

    if (!this.commonUtil.checkOnline()) {
      return;
    }

    const dialogRef = this.dialog.open(TagSettingDialogComponent, {
      width: Constant.tagEditDialogWidth,
      height: Constant.tagEditDialogHeight,
      autoFocus: false,
      disableClose: true,
    });
  }

  onauthDescriptionChange(value: string): void {
    this.authDescription = value;
    this.authDescriptionLength = value.length;
  }

  togglePermission() {
    this.isPermissionOpen = !this.isPermissionOpen;
  }

  changeTag(gc: FormGroup, tagId: number) {

    const tag = this.tagList.find(x => x.id === tagId);

    gc.patchValue({
      tag_id: tag?.id ?? null,
    });

  }

  onRelationOpen(opened: boolean, select: MatSelect, triggerEl: HTMLElement): void {
    if (!opened) {
      return;
    }

    const offset = -10
    setTimeout(() => this.alignSelectPanelToTrigger(select, triggerEl, offset));
  }

  onTagOpen(opened: boolean, select: MatSelect, triggerEl: HTMLElement) {

    if (!opened) {
      return;
    }
    const offset = 0
    setTimeout(() => this.alignSelectPanelToTrigger(select, triggerEl , offset));
  }

  private alignSelectPanelToTrigger(select: MatSelect, triggerEl: HTMLElement , offset): void {

    const panel = document.getElementById(`${select.id}-panel`);
    if (!panel) return;

    const pane = panel.closest('.cdk-overlay-pane') as HTMLElement;
    if (!pane) return;

    requestAnimationFrame(() => {

      const triggerRect = triggerEl.getBoundingClientRect();
      const panelWidth = pane.offsetWidth;
      //pane.style.minWidth = `${pane.offsetWidth + 40}px`;

      // Overlayが配置した位置との差分
      const paneRect = pane.getBoundingClientRect();

      const diff = triggerRect.right - paneRect.right + offset;

      pane.style.transform = `translateX(${diff}px)`;
    });
  }

  private getTagMaster(): Promise<void> {

    return Auth.currentSession().then(session => {

      const apiPath = '/tag/master';
      const options = this.auth.createApiHeader(session);

      return this.commonUtil.apiGet(apiPath, options)
        .then(res => {

          if (res.status === Constant.OK) {
            this.tagList = res.data;
            this.updatePanelWidth();
          }

        });

    });

  }

  async openTagSelect(select: MatSelect) {

    this.getTagMaster();

    select.open();

  }

  getTagName(id: number) {
    return this.tagList.find(x => x.id === id)?.title ?? '';
  }


  panelWidth = 0;

  private updatePanelWidth(): void {

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;

    // mat-option と同じフォント
    ctx.font = '400 13px Roboto';

    const maxText = Math.max(
      ...this.tagList.map(x => ctx.measureText(x.title).width)
    );

    const checkWidth = 14;     // ✓領域
    const horizontalPadding = 32;
    const safety = 8;

    this.panelWidth =
      Math.ceil(maxText + checkWidth + horizontalPadding + safety);
  }



  formatDate(dateStr: string): string {
    //return this.datePipe.transform(
    //  dateStr.replace(' ', 'T'), // MySQL形式対策
    //  'yyyy/MM/dd HH:mm',
    //  'Asia/Tokyo'
    //)!;
    const date = new Date(dateStr.replace(' ', 'T'));

    return date.toLocaleString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }

  get type1(): FormArray {
    return this.form.get('type1') as FormArray;
  }

  get type2(): FormArray {
    return this.form.get('type2') as FormArray;
  }

  get type3(): FormArray {
    return this.form.get('type3') as FormArray;
  }
  get type4(): FormArray {
    return this.form.get('type4') as FormArray;
  }

  get type5(): FormArray {
    return this.form.get('type5') as FormArray;
  }

  children(parentArray: FormArray, parentIndex: number): FormArray {
    return parentArray.at(parentIndex).get('children') as FormArray;
  }

  addGrandChild(parentArray: FormArray, parentIndex: number, childIndex: number) {

    const gcArray = this.grandChildren(parentArray, parentIndex, childIndex);

    gcArray.push(
      this.fb.group({
        id: [null],
        relation: new FormControl(0),
        tag_id: [null],
        name: ['', [Validators.required, Validators.maxLength(50)]],
        member_count: [''],
        delete: [false],
        enabled: [true]
      })
    );
  }

  getTypeArray(name: string): FormArray {
    return this.form.get(name) as FormArray;
  }

  addParent(type: 1 | 2 | 3 | 4 | 5, data?: ParentItem) {

    const group = this.fb.group({
      id: [data?.id ?? null],
      name: [data?.name ?? '', [Validators.required, Validators.maxLength(20)]],
      member_count: [data?.member_count ?? null],
      enabled: [data?.enabled ?? true],
      delete: [false],
      children: this.fb.array(
        (data?.children ?? []).map(child =>
          this.fb.group({
            id: [child.id ?? null],
            name: [child.name ?? '', [Validators.required, Validators.maxLength(20)]],
            member_count: [child?.member_count ?? null],
            enabled: [child.enabled ?? true],
            delete: [false],
            children: this.fb.array(
              (child.children ?? []).map(gc =>
                this.fb.group({
                  id: [gc.id ?? null],
                  relation: [gc.relation ?? null],
                  tag_id: [gc.tag_id ?? null],
                  name: [gc.name ?? '', [Validators.required, Validators.maxLength(50)]],
                  member_count: [gc.member_count ?? null],
                  enabled: [gc.enabled ?? true],
                  delete: [false],
                })
              )
            )
          })
        )
      )
    });

    if (type === 1) this.type1.push(group);
    if (type === 2) this.type2.push(group);
    if (type === 3) this.type3.push(group);
    if (type === 4) this.type4.push(group);
    if (type === 5) this.type5.push(group);
  }

  selectedParentIndex: { [key: number]: number } = {
    1: -1,
    2: -1,
    3: -1,
    4: -1,
    5: -1
  };

  selectedChildIndex: { [key: number]: number } = {
    1: -1,
    2: -1,
    3: -1,
    4: -1,
    5: -1
  };
  selectParent(type: number, index: number) {

    const parent = this.getTypeArray(this.masterTypes.find(m => m.type === type)?.form).at(index);

    if (parent.get('delete')?.value) return;

    this.selectedParentIndex[type] = index;
    this.selectedChildIndex[type] = -1;
  }

  selectChild(type: number, index: number) {

    const parentIndex = this.selectedParentIndex[type];
    if (parentIndex === -1) return;

    const child = this.children(
      this.getTypeArray(this.masterTypes.find(m => m.type === type)?.form),
      parentIndex
    ).at(index);

    if (child.get('delete')?.value) return;

    this.selectedChildIndex[type] = index;
  }

  hasVisibleChildren(formName: string, type: number): boolean {

    const parentIndex = this.selectedParentIndex[type];
    if (parentIndex === -1) return false;

    const arr = this.getTypeArray(formName);
    const children = this.children(arr, parentIndex);

    if (!children) return false;

    return children.controls.some(ctrl => !ctrl.get('delete')?.value);
  }

  hasVisibleGrandChildren(formName: string, type: number): boolean {

    const parentIndex = this.selectedParentIndex[type];
    const childIndex = this.selectedChildIndex[type];

    if (parentIndex === -1 || childIndex === -1) return false;

    const arr = this.getTypeArray(formName);
    const gcs = this.grandChildren(arr, parentIndex, childIndex);

    if (!gcs) return false;

    return gcs.controls.some(ctrl => !ctrl.get('delete')?.value);
  }
  hasVisibleGrandChildrenForChild(
    formName: string,
    type: number,
    childIndex: number
  ): boolean {

    const parentIndex = this.selectedParentIndex[type];

    if (parentIndex === -1) return false;

    const arr = this.getTypeArray(formName);
    const gcs = this.grandChildren(arr, parentIndex, childIndex);

    if (!gcs) return false;

    return gcs.controls.some(ctrl => !ctrl.get('delete')?.value);
  }

  grandChildren(parentArray: FormArray, parentIndex: number, childIndex: number): FormArray {

    const parent = parentArray.at(parentIndex) as FormGroup;
    if (!parent) return new FormArray([]);

    const children = parent.get('children') as FormArray;
    if (!children) return new FormArray([]);

    const child = children.at(childIndex) as FormGroup;
    if (!child) return new FormArray([]);

    const grandChildren = child.get('children') as FormArray;

    return grandChildren ?? new FormArray([]);
  }

  dropGrandChild(event: CdkDragDrop<FormArray>, typeArray: FormArray, parentIndex: number, childIndex: number) {

    const gcs = this.grandChildren(typeArray, parentIndex, childIndex);

    const visible = gcs.controls.filter(c => !c.get('delete')?.value);

    moveItemInArray(
      visible,
      event.previousIndex,
      event.currentIndex
    );

    let vIndex = 0;
    gcs.controls.forEach((ctrl, i) => {
      if (!ctrl.get('delete')?.value) {
        gcs.setControl(i, visible[vIndex++]);
      }
    });

    gcs.updateValueAndValidity();
  }

  dropParent(event: CdkDragDrop<FormArray>, control: FormArray) {

    const visible = control.controls.filter(c => !c.get('delete')?.value);

    moveItemInArray(
      visible,
      event.previousIndex,
      event.currentIndex
    );

    // 元の配列に戻す
    let vIndex = 0;
    control.controls.forEach((ctrl, i) => {
      if (!ctrl.get('delete')?.value) {
        control.setControl(i, visible[vIndex++]);
      }
    });
  }

  /* ===== 子 ===== */

  addChild(parentArray: FormArray, parentIndex: number, data?: ChildItem) {
    const childrenArray = parentArray
      .at(parentIndex)
      .get('children') as FormArray;

      childrenArray.push(
        this.fb.group({
          id: [data?.id ?? null],
          name: [data?.name ?? '', [Validators.required, Validators.maxLength(20)]],
          member_count: [data?.member_count ?? null],
          enabled: [data?.enabled ?? true],
          delete: [false],
          children: this.fb.array([])
        })
      );
  }

  dropChild(event: CdkDragDrop<FormArray>, parentArray: FormArray, parentIndex: number) {

    const childrenArray = parentArray
      .at(parentIndex)
      .get('children') as FormArray;

    const visible = childrenArray.controls.filter(c => !c.get('delete')?.value);

    moveItemInArray(
      visible,
      event.previousIndex,
      event.currentIndex
    );

    let vIndex = 0;
    childrenArray.controls.forEach((ctrl, i) => {
      if (!ctrl.get('delete')?.value) {
        childrenArray.setControl(i, visible[vIndex++]);
      }
    });
  }

  onSave(type: 1 | 2 | 3 | 4 | 5) {

    if (!this.commonUtil.checkOnline()) {
      this.showErrorToast(Constant.msgNetworkError);
      return;
    }

    if (this.cardLoading[type]) return;

    this.cardLoading[type] = true;

    let formArray: FormArray;

    switch (type) {
      case 1:
        formArray = this.type1;
        break;
      case 2:
        formArray = this.type2;
        break;
      case 3:
        formArray = this.type3;
        break;
      case 4:
        formArray = this.type4;
        break;
      case 5:
        formArray = this.type5;
        break;
    }

    const masterdata = this.buildMasterData(type, formArray);

    if (masterdata.length === 0) {
      masterdata.push({
        master_type: type,
        empty: true
      });
    }
    this.dataUpdate(type, masterdata);
  }

  onDel(type: 1 | 2 | 3 | 4 | 5) {
    if (!this.commonUtil.isOnline()) {
      this.showErrorToast(Constant.msgNetworkError);
      return;
    }

    if (this.cardLoading[type]) return;

    this.cardLoading[type] = true;

    const dialogRef = this.dialog.open(GeneralYesNoDialogComponent, {
      width: '500px',
      autoFocus: false,
      data: { msg: Constant.pcMsgComfirmDel }
    });
    dialogRef.afterClosed().subscribe(isOK => {
      if (isOK) {
        let formArray: FormArray;

        switch (type) {
          case 1:
            formArray = this.type1;
            break;
          case 2:
            formArray = this.type2;
            break;
          case 3:
            formArray = this.type3;
            break;
          case 4:
            formArray = this.type4;
            break;
          case 5:
            formArray = this.type5;
            break;
        }

        const masterdata = this.buildMasterData(type, formArray);

        if (masterdata.length === 0) {
          masterdata.push({
            master_type: type,
            empty: true
          });
        }

        this.dataUpdate(type, masterdata);
      }
    });
  }

  truncate(text: string, length = 12): string {
    if (!text) return '';
    return text.length > length ? text.slice(0, length) + '...' : text;
  }

  deleteMode: { [key: number]: boolean } = {};

  onDelete(type: number) {

    // 削除モード → 編集モードに戻す
    if (this.deleteMode[type]) {

      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      this.deleteMode[type] = false;

      // チェックを全部外す
      const formArray = this.getTypeArray(`type${type}`);

      formArray.controls.forEach(parentCtrl => {

        //parentCtrl.get('delete')?.setValue(false);

        const children = parentCtrl.get('children') as FormArray;

        children.controls.forEach(childCtrl => {

          //childCtrl.get('delete')?.setValue(false);

          const grandChildren = childCtrl.get('children') as FormArray;

          grandChildren.controls.forEach(gcCtrl => {
            //gcCtrl.get('delete')?.setValue(false);
          });

        });

      });

      return;
    }

    // 削除モードに入る確認
    const dialogRef = this.dialog.open(GeneralYesNoDialogComponent, {
      width: '400px',
      autoFocus: false,
      data: { msg: Constant.pcMsgComfirmDel }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result === true) {
        this.deleteMode[type] = true;
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
      }

    });

  }



  toggleParentDelete(parent: FormGroup) {

    const checked = parent.get('delete')?.value;

    const children = parent.get('children') as FormArray;

    children.controls.forEach((child: any) => {

      child.get('delete')?.setValue(checked);

      const grandChildren = child.get('children') as FormArray;

      grandChildren.controls.forEach((gc: any) => {
        gc.get('delete')?.setValue(checked);
      });

    });

  }

  hasChildError(parent: FormGroup): boolean {

    const children = parent.get('children') as FormArray;
    if (!children) return false;

    return children.controls.some(child => {

      if (child.get('delete')?.value) return false;

      if (!child.get('name')?.value) return true;

      const grandChildren = child.get('children') as FormArray;

      if (!grandChildren) return false;

      return grandChildren.controls.some(gc => {

        if (gc.get('delete')?.value) return false;

        return !gc.get('name')?.value;

      });

    });
  }

  isParentError(parent: FormGroup): boolean {

    if (parent.get('delete')?.value) return false;

    // 親自身
    if (parent.get('name')?.invalid) return true;

    const children = parent.get('children') as FormArray;

    if (!children) return false;

    // 子のエラーを見る
    return children.controls.some(child => this.isChildError(child as FormGroup));
  }

  isChildError(child: FormGroup): boolean {

    if (child.get('delete')?.value) return false;

    // 子自身
    if (child.get('name')?.invalid) return true;

    const gcs = child.get('children') as FormArray;

    if (!gcs) return false;

    // 孫エラーを見る
    return gcs.controls.some(gc => this.isGrandChildError(gc as FormGroup));
  }

  isGrandChildError(gc: FormGroup): boolean {

    if (gc.get('delete')?.value) return false;

    return gc.get('name')?.invalid;
  }

  toggleChildDelete(child: FormGroup) {

    const checked = child.get('delete')?.value;

    const grandChildren = child.get('children') as FormArray;

    grandChildren.controls.forEach((gc: any) => {
      gc.get('delete')?.setValue(checked);
    });

  }

  isAllEmptyChecked(formName: string): boolean {

    const arr = this.form.get(formName) as FormArray;
    if (!arr) return false;

    let hasEmpty = false;

    for (const parent of arr.controls) {

      const parentName = parent.get('name')?.value;

      if (!parentName) {
        hasEmpty = true;
        if (!parent.get('delete')?.value) return false;
      }

      const children = parent.get('children') as FormArray;

      for (const child of children.controls) {

        const childName = child.get('name')?.value;

        if (!childName) {
          hasEmpty = true;
          if (!child.get('delete')?.value) return false;
        }

        const gcs = child.get('children') as FormArray;

        for (const gc of gcs.controls) {

          const gcName = gc.get('name')?.value;

          if (!gcName) {
            hasEmpty = true;
            if (!gc.get('delete')?.value) return false;
          }

        }

      }

    }

    return hasEmpty;
  }



  /*
   * プライベート関数
   */

  // 記事情報を取得する
  private getMasterData(type?: 1 | 2 | 3 | 4 | 5) {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
      return;
    }

    this.loadAuthDescription();

    Auth.currentSession().then(session => {
      let apiPath = this.apiPath;
      if (type) {
        apiPath = apiPath +"/" + type;
      }
      const options = this.auth.createApiHeader(session);
      this.commonUtil.apiGet(apiPath, options).then(res => {
        if (!res.data) {
          // 削除済み
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgDeleteContentAlreadyError, Constant.toastShowMiliSec);
          return;
        }
        console.log(res)
        if (res.status === 'OK') {

          const master = res.data.master;
          const types = type ? [type] : [1,2,3,4,5];

          const data = res.data;
          this.history = data.history;

          const masterCount = data.master_count ?? {};

          for (const key of Object.keys(masterCount)) {
            this.form.get(`type${key}_member_count`)?.setValue(
              masterCount[key].member_count ?? ''
            );
          }

          types.forEach(t => {

            const formArray = this.getTypeArray(`type${t}`);
            formArray.clear(); // ← 既存削除
            this.selectedParentIndex[t] = -1;
            this.selectedChildIndex[t] = -1;
            //this.deleteMode[t] = false;


            master[t]?.forEach((parent: ParentItem) => {
              this.addParent(t as 1 | 2 | 3 | 4 | 5, parent);
            });

          });
        }
        this.showSpinner = false;

      })
      .catch(err => {
        this.commonUtil.debug().log(err);
        if (err.message === Constant.msgLoginFailed) {
          this.commonUtil.showReloadDialog(this.auth);
        } else{
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
        }
      });
    });
  }

  private initForm() {
    this.form = this.fb.group({
      type1: this.fb.array([]),  // 本部
      type2: this.fb.array([]),  // 支部
      type3: this.fb.array([]),   // エリア
      type4: this.fb.array([]),   // 専門部
      type5: this.fb.array([]) ,  // 役職

      type1_member_count: [''],
      type2_member_count: [''],
      type3_member_count: [''],
      type4_member_count: [''],
      type5_member_count: [''],
      authDescription: ['', [Validators.maxLength(1000)]],
    });

    // 初期データ
    //this.addParent('〇〇分会', true);
  }

  // トースト表示
  private showToast(msg) {
    this.toastUtil.clearAllShowingToast();
    this.toastUtil.showInformationToast(Constant.empty, msg, Constant.toastShowMiliSec);
  }

  // エラートースト表示
  private showErrorToast(msg) {
    this.toastUtil.clearAllShowingToast();
    this.toastUtil.showErrorToast(Constant.empty, msg, Constant.toastShowMiliSec);
  }

  isTypeInvalid(formName: string): boolean {

    const arr = this.form.get(formName) as FormArray;
    if (!arr) return true;

    for (const parent of arr.controls) {

      if (parent.get('delete')?.value) continue;

      if (parent.get('name')?.invalid) return true;

      const children = parent.get('children') as FormArray;

      for (const child of children.controls) {

        if (child.get('delete')?.value) continue;

        if (child.get('name')?.invalid) return true;

        const gcs = child.get('children') as FormArray;

        for (const gc of gcs.controls) {

          if (gc.get('delete')?.value) continue;

          if (gc.get('name')?.invalid) return true;

        }

      }

    }

    return false;
  }

  onlyNumber(event: any) {
    const value = event.target.value.replace(/[^0-9]/g, '');
    event.target.value = value;
  }

  private buildMasterData(type: 1 | 2 | 3 | 4 | 5, formArray: FormArray) {

    const result: any[] = [];

    let parentSort = 1;

    formArray.controls.forEach(parentCtrl => {

      const parent = parentCtrl.getRawValue();

      if (parent.delete) {
        if (parent.id) {
          result.push({
            master_type: type,
            id: parent.id,
            delete: true
          });
        }
        return;
      }

      const parentData: any = {
        master_type: type,
        id: parent.id,
        name: parent.name,
        member_count:
          parent.member_count !== null &&
          parent.member_count !== undefined &&
          parent.member_count !== ''
            ? Number(parent.member_count)
            : null,
        enabled: parent.enabled,
        sort_order: parentSort++,
        children: []
      };

      let childSort = 1;

      parent.children?.forEach(child => {

        if (child.delete) {
          if (child.id) {
            result.push({
              master_type: type,
              id: child.id,
              delete: true
            });
          }
          return;
        }

        const childData: any = {
          id: child.id,
          name: child.name,
          member_count:
            child.member_count !== null &&
            child.member_count !== undefined &&
            child.member_count !== ''
              ? Number(child.member_count)
              : null,
          enabled: child.enabled,
          sort_order: childSort++,
          children: []
        };

        let gcSort = 1;

        child.children?.forEach(gc => {

          if (gc.delete) {
            if (gc.id) {
              result.push({
                master_type: type,
                id: gc.id,
                delete: true
              });
            }
            return;
          }

          childData.children.push({
            id: gc.id,
            relation:
            gc.relation === null || gc.relation === undefined
              ? null
              : Number(gc.relation),
            tag_id: gc.tag_id,
            name: gc.name,
            member_count:
              gc.member_count !== null &&
              gc.member_count !== undefined &&
              gc.member_count !== ''
                ? Number(gc.member_count)
                : null,
            enabled: gc.enabled,
            sort_order: gcSort++
          });

        });

        parentData.children.push(childData);

      });

      result.push(parentData);

    });

    return result;
  }

    deleteNode(event: Event, ctrl: FormGroup, type: number, index: number) {

      event.stopPropagation();

      ctrl.patchValue({ delete: true });
      this.cascadeDisable(ctrl);

      const parentIndex = this.selectedParentIndex[type];
      const childIndex = this.selectedChildIndex[type];

      // 親削除
      const typeArray = this.getTypeArray(`type${type}`);
      if (typeArray.at(index) === ctrl) {
        this.selectedParentIndex[type] = -1;
        this.selectedChildIndex[type] = -1;
        return;
      }

      // 小分類削除
      if (parentIndex !== -1) {

        const children = this.children(typeArray, parentIndex);

        if (children.at(index) === ctrl) {

          if (this.selectedChildIndex[type] === index) {
            this.selectedChildIndex[type] = -1;
          }

          return;
        }
      }

      // 最小分類削除
      if (parentIndex !== -1 && childIndex !== -1) {

        const gcs = this.grandChildren(typeArray, parentIndex, childIndex);

        if (gcs.at(index) === ctrl) {

          if (gcs.length <= 1) {
            this.selectedChildIndex[type] = -1;
          }

        }

      }

    }

    cascadeDisable(node: FormGroup) {
      node.patchValue({ delete: true, enabled: false });

      Object.keys(node.controls).forEach(key => {
        const control = node.get(key);

        if (control instanceof FormArray) {
          control.controls.forEach((child: FormGroup) => {
            this.cascadeDisable(child);
          });
        }
      });
    }

  // 登録実行
  private dataUpdate(type: 1 | 2 | 3 | 4 | 5, masterdata: any[], isDelete = false) {

    Auth.currentSession().then(session => {

      const options = this.auth.createApiHeader(session);

      options['body'] = {
        masterdata,
        master_count: {
          master_type: type,
          member_count:
          this.form.get(`type${type}_member_count`)?.value !== null &&
          this.form.get(`type${type}_member_count`)?.value !== undefined &&
          this.form.get(`type${type}_member_count`)?.value !== ''
            ? Number(this.form.get(`type${type}_member_count`)?.value)
            : null,
        }
      };

      console.log(options);

      this.commonUtil
        .apiPost(this.apiPath, options)
        .then(res => {

          this.cardLoading[type] = false;

          if (res.status === Constant.OK) {

            this.toastUtil.showInformationToast(
              '',
              Constant.msgResultSaveSuccess,
              Constant.toastShowMiliSec
            );

            this.getMasterData(type);
          }

        })
        .catch(err => {

          this.commonUtil.debug().log(err);

          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else {

            this.toastUtil.showErrorToast(
              '',
              Constant.msgSaveFailedRetry,
              Constant.toastShowMiliSec
            );
          }
          this.cardLoading[type] = false;
        });

    });
  }

  authDescriptionOnSave() {
    if (!this.commonUtil.checkOnline()) {
      return;
    }

    // 10000文字以上はカット
    if (this.authDescription.length > 1000) {
      this.authDescription = this.authDescription.substring(0, 10000);
    }
    console.log(this.authDescription)

    this.cardLoading[6] = true;

    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      options['body'] = {
        auth_description: this.authDescription
      };
      this.commonUtil
        .apiPost('/master/authdescription', options)
        .then(res => {

          this.cardLoading[6] = false;
          if (res.status === Constant.OK) {
            this.toastUtil.showInformationToast('', Constant.msgResultSaveSuccess, Constant.toastShowMiliSec);
            //this.showSpinner = true;
            this.loadAuthDescription();
          }
        })
        .catch(err => {
          this.commonUtil.debug().log(err);
          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else {
            this.toastUtil.showErrorToast('', Constant.msgSaveFailedRetry, Constant.toastShowMiliSec);
          }
          this.cardLoading[6] = false;
        });
    });
  }

  private loadAuthDescription() {
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);

      this.commonUtil
        .apiGet('/master/authdescription', options)
        .then(res => {
          console.log(res)
          if (res.status === Constant.OK) {

            this.form.patchValue({
              authDescription: res.data.auth_description
            });

            this.authDescriptionHistory = res.data;
          }
        })
        .catch(err => {
          this.commonUtil.debug().log(err);
        });
    });
  }
}
